import { render, staticRenderFns } from "./SpeakerCard.vue?vue&type=template&id=d28d4a9a&scoped=true&"
import script from "./SpeakerCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerCard.vue?vue&type=style&index=0&id=d28d4a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28d4a9a",
  null
  
)

export default component.exports